/* PauseAction.js */

"use strict";

const PAUSE_MESSAGE = "Are you sure you want to pause the selected schedule from being run?";
const RESUME_MESSAGE = "Are you sure you want to resume running the selected schedule?";
const PAUSE_TITLE = "Pause";
const RESUME_TITLE = "Resume";
const ALLOWED_STATUSES = ["ACTIVE", "PAUSED"];
const NOT_ALLOWED_MESSAGE =
    "This schedule can neither be paused nor resumed. Please review and try again.";
// const IS_RUNNING = 'RUN_NOW';
const WorkTrigFutureViewComponent = require("../../views/worktrig_future/WorkTrigFutureViewComponent");
const {managerFor, refusalMessage} = require("../../../../lib/managedSchedules");

class PauseAction {
    constructor(logger, gameEditor, activeView, modalUserFeedback) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._activeView = activeView;
        this._workTrig = gameEditor.getTriggerType();
        this._modalUserFeedback = modalUserFeedback;

        if (
            this._activeView &&
            this._activeView instanceof WorkTrigFutureViewComponent &&
            this._activeView.pagingFeed
        ) {
            this._selectedFutureIds = this._activeView.getSelectedFutureIds().selectedRows || [];
        }
    }

    run() {
        let isPaused = false;
        let action = () => {};
        // temporary disable as it increase user experience complexity
        //
        // if (this._selectedFutureIds && this._selectedFutureIds.length === 1) {
        //     let entity = this._activeView.pagingFeed.getEntityById(this._selectedFutureIds[0]);
        //     if (entity) {
        //         //isPaused = entity.status !== IS_RUNNING;
        //         isPaused = true;
        //         action = () => {
        //             // return isPaused ? entity.skipOccurrence() : this._workTrig.pauseTriggers();
        //             return entity.skipOccurrence();
        //         };
        //     } else {
        //         return Promise.reject('Can\'t find selected future Work Trigger!');
        //     }
        // } else {
        isPaused = this._workTrig.isPaused;
        action = () => {
            return isPaused ? this._workTrig.resumeTriggers() : this._workTrig.pauseTriggers();
        };
        // }

        // Refused because a pause here sticks: the owning sync writes the schedule, not
        // status/isPaused, so the settings page would still report the schedule as enabled.
        const manager = managerFor(this._workTrig);
        if (manager) {
            return this._modalUserFeedback.displayError({
                errorMsg: refusalMessage(manager, isPaused ? "resumed" : "paused"),
                errorCode: "",
                title: isPaused ? RESUME_TITLE : PAUSE_TITLE,
            });
        }

        const status = this._workTrig.status;
        if (!ALLOWED_STATUSES.includes(status)) {
            return this._modalUserFeedback.displayError({
                error: {
                    errorTitle: "Error",
                    errorMsg: NOT_ALLOWED_MESSAGE,
                    errorCode: "",
                },
            });
        }

        return this._gameEditor.runQuickConfirmationActionWorkflow(
            {
                message: isPaused ? RESUME_MESSAGE : PAUSE_MESSAGE,
                title: isPaused ? RESUME_TITLE : PAUSE_TITLE,
                confirmDetails: {
                    // text: this._workTrig.isPaused ? RESUME_TITLE : PAUSE_TITLE,
                    text: "Confirm",
                    type: "additive",
                },
                rejectDetails: {
                    text: "Cancel",
                    type: "text",
                },
            },
            () => {
                return action();
            }
        );
    }
}

module.exports = PauseAction;

PauseAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "gameEditor.activeView",
    "$teve.ui.userFeedback",
];

PauseAction.$displayDetails = {
    type: "Action",
    name: "PauseAction",
    icon: "worktrigger.pause",
    title: "Pause/Resume",
    shown: true,
    order: 2,
};
